import { render, staticRenderFns } from "./LocationAreasFilter.vue?vue&type=template&id=5892b02c&scoped=true"
import script from "./LocationAreasFilter.vue?vue&type=script&lang=js"
export * from "./LocationAreasFilter.vue?vue&type=script&lang=js"
import style0 from "./LocationAreasFilter.vue?vue&type=style&index=0&id=5892b02c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5892b02c",
  null
  
)

export default component.exports